import { Legend as LegendBase } from './Legend';
import { LegendChecklistItem } from './Legend.ChecklistItem';
import { LegendItem } from './Legend.Item';
export var Legend = Object.assign(LegendBase, {
  Item: LegendItem,
  ChecklistItem: LegendChecklistItem
});